/* istanbul ignore file */
import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./resetSlice";
const initialState = {
	authRes: false,
	languageParam: "",
	arabicLanguageParam:false,
	authenticationResponse: {},
	getAllEnLabels: [],
	authToken: "",
	resetPasswordResponse: [],
	esmaBarResponseData: [],
	getUserLocation: "",
	expiredLinkValidationRes: {},
	forgotUserRes: {},
	forgotUserResSucc: "",
	esmaText: "",
	transliterationRules: [],
	forgotPass: {},
	autoLoginResponse: {},
	userEntity: "",
	authError: {},
	rbName: '',
	rb_platformOptions: [],
	rb_defaultPlatform: '',
	rb_denominationOptions: [],
	liveChatStatus: "",
	liveAgentID:"",
	languageChange: false,
	allDependencyCheck: false,
	langList: null,
	loginRes: { data: { "user-details": { platform: "" } } }
};
const signUpSlice = createSlice({
	name: "signUp",
	initialState,
	reducers: {
		autentication: (state, action) => {
			state.signUpRes = action.payload;
			state.authRes = action.payload.success || action.payload.authRes;
			state.authenticationResponse = action.payload.data;
			state.authToken = action.payload.data
				? action.payload.data["login-response"].token
				: action.payload.authToken;

			state.authError = {};
			state.rb_platformOptions =  action.payload.data ? action.payload.data["signup-response"].users[0].rbPlatformOption : action.payload.rb_platformOptions;
			state.rb_defaultPlatform =  action.payload.data ? action.payload.data["signup-response"].users[0].rbDefaultPlatform : action.payload.rb_defaultPlatform;
			state.rb_denominationOptions =  action.payload.data ? action.payload.data["signup-response"].users[0].rbDenominationOptions : action.payload.rb_denominationOptions;
		},
		authenticationError: (state, action) => {
			state.authError = action.payload;
		},
		languagequeryParam: (state, action) => {
			state.languageParam = action.payload;
		},
		arabicLanguagequeryParam: (state, action) => {
			state.arabicLanguageParam = action.payload;
		},
		storelangList: (state, action) => {
            state.langList = action.payload;
          },
		allDependencyCheckParam: (state, action) => {
			state.allDependencyCheck = action.payload;
		},
		setUserEntity: (state, action) => {
			state.userEntity = action.payload;
		},
		updatePlatformValue: (state, action) => {
			if(state?.loginRes?.data?.["user-details"]) {
				state.loginRes.data["user-details"].platform = action.payload;
			}
		},
		loginResponse: (state, action) => {
			state.loginRes = action.payload;
			state.authRes = action.payload.success;
			state.authToken = action.payload?.data
				? action.payload?.data["login-response"]?.token
				: action.payload?.authToken ? action.payload?.authToken : "";

			// CX-50999: a failed login (bad credentials / lockout) also lands here. auth.service.js
			// synthesizes data["user-details"] carrying only userLocale, so the old
			// `data ? data["user-details"].entity : ""` wrote undefined over the geo-resolved entity.
			// App.js gates the whole route tree on userEntity, so that blanked entity unmounted and
			// remounted Login, discarding the invalid-credentials message before the user saw it.
			// Only overwrite when the response actually carries an entity.
			const responseEntity = action.payload?.data?.["user-details"]?.entity;
			if (responseEntity) {
				state.userEntity = responseEntity;
			}
			state.rbName = action.payload.data
				? action.payload.data["user-details"].rbName
				: "";
				state.rb_platformOptions =  action.payload.data ? action.payload.data["user-details"].rbPlatformOption : action.payload.rb_platformOptions;
			state.rb_defaultPlatform = action.payload.data
				? action.payload.data["user-details"].rbDefaultPlatform
				: action.payload.rb_defaultPlatform;
			state.rb_denominationOptions =  action.payload.data ? action.payload.data["user-details"].rbDenominationOptions : action.payload.rb_denominationOptions;
			state.languageParam = action.payload?.data && action.payload?.data["user-details"] && action.payload.data["user-details"].userLocale;
		},
		setAllEnLabels: (state, action) => {
			state.getAllEnLabels = action.payload;
		},
		forgotUsernameResponse: (state, action) => {
			state.forgotUserRes = action.payload;
		},
		forgotUsernameSuccess: (state, action) =>{
            state.forgotUserResSucc = action.payload;
		},
		forgotPasswordResponse: (state, action) => {
			state.forgotPass = action.payload;
		},
		resetPasswordRes: (state, action) => {
			state.resetPasswordResponse = action.payload;
		},
		removeForgotUsername: (state, action) => {
			state.forgotUserRes = {};
		},
		removeForgotPass: (state, action) => {
			state.forgotUserRes = {};
			state.resetPasswordResponse = {};
			state.expiredLinkValidationRes = {};
			state.forgotPass = {};
		},
		additionalProperties: (state, action) => {
			state.loginRes = {};
		},
		setCountryListInState: (state, action) => {
			state.countryList = action.payload;
		},
		esmaBarResponse: (state, action) => {
			state.esmaBarResponseData = action.payload;
		},
		getUserCurrentLocation: (state, action) => {
			state.getUserLocation = action.payload;
		},
		linkExpiredValidationResponse: (state, action) => {
			state.expiredLinkValidationRes = action.payload;
		},
		storeEsmaText: (state, action) => {
			state.esmaText = action.payload;
		},
		setTransliterationTable: (state, action) => {
			state.transliterationRules = action.payload;
		},
		autoLoginResponseData: (state, action) => {
			let autoLoginMessage = action?.payload?.data["login-response"]?.message;
			if (autoLoginMessage === "Login Success") {
				state.autoLoginResponse = action.payload;
				state.loginRes = action.payload;
				state.authRes = action.payload.success;
				state.authToken = action.payload.data
					? action.payload.data["login-response"].token
					: "";
				state.userEntity = action.payload.data
					? action.payload.data["user-details"].entity
					: "";
				state.rbName = action.payload.data
					? action.payload.data["user-details"].rbName
					: "";
				state.rb_platformOptions = action.payload.data ? action.payload.data["user-details"].rbPlatformOption : [];
				state.rb_defaultPlatform = action.payload.data
					? action.payload.data["user-details"].rbDefaultPlatform
					: "";
				state.languageParam = action.payload.data
					? action.payload.data["user-details"].userLocale
					: "";
				state.rb_denominationOptions = action.payload.data ? action.payload.data["user-details"].rbDenominationOptions : [];
			} else {
				let autoResponse = JSON.parse(JSON.stringify(action.payload));
				autoResponse.data["login-response"].email = autoResponse?.data["user-details"]?.email
				delete autoResponse.data["user-details"]
				state.autoLoginResponse = autoResponse;
			}

		},
		clearAuthResp: (state, action) => {
			state.authRes = false;
			state.authError = {}
			state.rbName = ""
		},
		setReferingBroker: (state, action) => {
			state.rbName = action.payload;
		},
		liveChat: (state,action)=>{
            state.liveChatStatus = action.payload;
        },
		liveChatID: (state,action)=>{
            state.liveAgentID = action.payload;
        },
		languageChangeSlice: (state, action) =>{
			state.languageChange = action.payload;
		},
		updateLoginCurrentStep: (state, action) =>{
			state.loginRes = state.loginRes || {};
			state.loginRes.data = state.loginRes.data || {};
			state.loginRes.data['user-details'] = state.loginRes.data['user-details'] || {};
			state.loginRes.data['user-details'].userForms = action.payload;
		},
		coolingPeriodSlice: (state, action) =>{
			state.coolingPeriod = action.payload;
		},
		clearPKAData: (state) => {
			if(state.loginRes?.data?.["user-details"])state.loginRes.data["user-details"].pkainfo = undefined
		},
		clearResults() {},
	},
	extraReducers: (builder) => {
		builder.addCase(resetAll, () => {
			return signUpSlice.getInitialState();
		});
	},
});
// Storing the query param of language for login page
export const selectedLanguage = (lang) => async (dispatch) => {
	dispatch(languagequeryParam(lang));
};
export const storeEsmaCompleteText = (text) => async (dispatch) => {
	dispatch(storeEsmaText(text));
};
export const clearAuthResponse = () => async (dispatch) => {
	dispatch(clearAuthResp());
};
export const setUserCurrentLocation = (location) => async (dispatch) => {
	dispatch(getUserCurrentLocation(location));
};
export const {
	autentication,
	languagequeryParam,
	arabicLanguagequeryParam,
	loginResponse,
	setAllEnLabels,
	forgotPasswordResponse,
	removeForgotPass,
	clearResults,
	resetPasswordRes,
	setCountryListInState,
	setUserEntity,
	storelangList,
	esmaBarResponse,
	getUserCurrentLocation,
	linkExpiredValidationResponse,
	forgotUsernameResponse,
	forgotUsernameSuccess,
	storeEsmaText,
	setTransliterationTable,
	autoLoginResponseData,
	clearAuthResp,
	additionalProperties,
	authenticationError,
	setReferingBroker,
	removeForgotUsername,
	liveChat,
	liveChatID,
	languageChangeSlice,
	allDependencyCheckParam,
	updatePlatformValue,
	updateLoginCurrentStep,
	coolingPeriodSlice,
	clearPKAData
} = signUpSlice.actions;
export default signUpSlice.reducer;
